import React from 'react'
import ApplicationResponsiveModal from '../../common/ApplicationResponsiveModal'
import {formatAustralianAgentPhone, normalizeAustralianPhone} from '../renterHomeUtils'

export type ContactAction = 'call' | 'email'

export type ApplicationContact = {
  name: string
  phone?: string
  email?: string
}

type ApplicationContactModalProps = {
  contactAction: ContactAction
  submissionId: string
  contacts: ApplicationContact[]
  onClose: () => void
}

type ApplicationContactItem = ApplicationContact & {
  value: string
}

const ApplicationContactModal: React.FC<ApplicationContactModalProps> = ({
  contactAction,
  submissionId,
  contacts,
  onClose,
}) => {
  const contactItems = contacts.reduce<ApplicationContactItem[]>((items, contact) => {
    const value = contactAction === 'call' ? contact.phone?.trim() : contact.email?.trim()
    if (!value) {
      return items
    }

    return [...items, {...contact, value}]
  }, [])

  return (
    <ApplicationResponsiveModal
      ariaLabelledBy={`application-contact-modal-title-${submissionId}`}
      closeAriaLabel={`Close ${contactAction} dialog`}
      onClose={onClose}
      modalClassName='application-household-modal'
      closeButtonClassName='application-household-modal-close'
      mobileAnimationMs={500}
      swipeTarget='sheet'
    >
      {(closeModal) => (
        <div className='application-household-modal-body'>
          <h2
            id={`application-contact-modal-title-${submissionId}`}
            className='application-household-modal-title mb-3'
          >
            {contactAction === 'call' ? 'Call' : 'Email'} agent
          </h2>

          <div className='stack'>
            {contactItems.map((contact) => (
              <a
                href={contactAction === 'call' ? `tel:${contact.value}` : `mailto:${contact.value}`}
                className='phone-link'
                onClick={closeModal}
                key={`${contact.name}-${contact.value}`}
              >
                <div className='icon'>
                  {contactAction === 'call' ? (
                    <svg
                      width='16'
                      height='16'
                      viewBox='0 0 20 20'
                      fill='none'
                      stroke='#0A7C5A'
                      strokeWidth='2.2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <path d='M15.5 13l-2.5-1.2a1 1 0 00-1.1.2l-1 1a10 10 0 01-4-4l1-1a1 1 0 00.2-1.1L6.9 4.5a1 1 0 00-1.1-.5l-2 .5a1.2 1.2 0 00-.9 1.2C3.3 11.4 8.6 16.7 14.3 17a1.2 1.2 0 001.2-.9l.5-2a1 1 0 00-.5-1.1z'></path>
                    </svg>
                  ) : (
                    <svg
                      width='16'
                      height='16'
                      viewBox='0 0 20 20'
                      fill='none'
                      stroke='#0A7C5A'
                      strokeWidth='2'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    >
                      <rect x='2.5' y='4.5' width='15' height='11' rx='1.5'></rect>
                      <path d='M3 6l7 5 7-5'></path>
                    </svg>
                  )}
                </div>
                <div className='phone-info'>
                  <div className='name'>{contact.name}</div>
                  <div className='phonenumber'>{contact.value}</div>
                </div>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 20 20'
                  fill='none'
                  stroke='#9CA3AF'
                  strokeWidth='1.6'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path d='M8 4l6 6-6 6'></path>
                </svg>
              </a>
            ))}
            {contactItems.length === 0 && (
              <div className='phone-link'>
                <div className='icon'>
                  <i className='bi bi-exclamation-circle' aria-hidden='true'></i>
                </div>
                <div className='phone-info'>
                  <div className='name'>No contact available</div>
                  <div className='phonenumber'>
                    {contactAction === 'call' ? 'No phone numbers found' : 'No emails found'}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </ApplicationResponsiveModal>
  )
}

export default ApplicationContactModal
